import React, { ReactNode } from 'react';
import { getContactAvatar } from 'flow/utils';
import useContact from 'flow/hooks/useContact';
import useAppContext from 'flow/hooks/useAppContext';
import UserAvatar from 'flow/components/ui-components/UserAvatar';
import SettingsListItem from '../custom-components/SettingsListItem';

interface Props {
    toggleButton: ReactNode;
}

const PbxMemberLoggedInStatusItem = ({ toggleButton }: Props) => {
    const { i18next } = useAppContext();
    const { ownContact } = useContact();

    return (
        <SettingsListItem
            description={toggleButton}
            className="py-2"
            dataTestId="pbx-login-list-item"
        >
            <div className="flex items-center gap-x-2">
                <UserAvatar src={getContactAvatar(ownContact)} />

                <div>{i18next.t('pbx.loggedin')}</div>
            </div>
        </SettingsListItem>
    );
};

export default PbxMemberLoggedInStatusItem;
